import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=649576b4&scoped=true&"
import script from "./Stats.vue?vue&type=script&lang=js&"
export * from "./Stats.vue?vue&type=script&lang=js&"
import style0 from "./Stats.vue?vue&type=style&index=0&id=649576b4&prod&lang=scss&"
import style1 from "./Stats.vue?vue&type=style&index=1&id=649576b4&prod&lang=css&"
import style2 from "./Stats.vue?vue&type=style&index=2&id=649576b4&prod&lang=css&"
import style3 from "./Stats.vue?vue&type=style&index=3&id=649576b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649576b4",
  null
  
)

export default component.exports